<template>
  <div class="login">
    <div>
      <div>
        <img src="../assets/image/welcome.png" />
      </div>
      <div>
        <div>
          <img src="../assets/image/icon.png" />
        </div>
        <div>
          <div>
            <input
              type="text"
              class="radius"
              placeholder="帳號 / Account"
              v-model="username"
              @keyup.enter="getLogin"
            />
          </div>
          <div>
            <input
              type="password"
              class="radius"
              placeholder="密碼 / Password"
              v-model="password"
              @keyup.enter="getLogin"
            />
          </div>
        </div>
        <div>
          <button class="outline" @click="getLogin">登入</button>
        </div>
        <div class="errMsg">
          {{ errMsg }}
        </div>
      </div>
    </div>

    <!-- <Loading /> -->
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import { login } from '../assets/api/user';
import { createLoginWatch } from '../assets/api/loginWatch';
// import Loading from '../components/Loading.vue';

export default {
  name: 'Login',
  components: {
    // Loading,
  },
  data() {
    return {
      username: '',
      password: '',
      errMsg: '',
    };
  },
  computed: {
    ...mapState('common', ['user']),
  },
  watch: {
    user: {
      deep: true,
      handler(val) {
        const { token, name, id } = val;
        this.$cookies.set('CWLUser', { name, id, token }, 60 * 60 * 4);

        let url;

        const role = id.slice(0, 2);

        switch (role) {
          case 'SW':
            url = '/';
            break;
          case 'TW':
            url = '/classesAndQuestions';
            break;
          case 'AW':
            url = '/admin';
            break;
          default:
        }

        this.$router.push(url);
      },
    },
  },
  methods: {
    async getLogin() {
      if (this.username && this.password) {
        const formData = new FormData();
        formData.set('username', this.username);
        formData.set('password', this.password);
        formData.set('grant_type', '');
        formData.set('scope', '');
        formData.set('client_id', '');
        formData.set('client_secret', '');

        try {
          const { data } = await login(formData, 'CodingWizard');

          fetch('https://api.ipify.org?format=json')
            .then((response) => response.json())
            .then((res) => {
              createLoginWatch({
                login_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                ip_address: res.ip,
              });
            })
            .catch(() => {
              // console.error('Error:', error);
            });

          this.$store.commit('common/SET_USER_INFO',
            { token: data.access_token, id: data.cw_id, name: data.name });
        } catch (err) {
          if (err.response) {
            const { detail } = err.response.data;
            if (detail === 'Invalid credentials' || detail === 'Incorrect cw_password') {
              this.errMsg = '帳號或密碼輸入錯誤，請確認後重新輸入。';
            }
          } else {
            this.errMsg = '伺服器發生了點問題，請稍候再試。';
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  background: $main-yellow;
  min-height: 100vh;
  padding: 0 60px 0 40px;

  @media (max-width: 480px){
    padding: 0;
  }

  > div {
    display: flex;
    align-items: center;

    @media (min-width: 480px){
      height: calc(100vh - 66px);
    }

    @media (max-width: 480px){
      flex-direction: column;
    }

    > div {
      flex: 1;

      &:first-child {
        margin-right: 40px;

        img {
          width: 100%;
        }

        @media (max-width: 480px){
          margin-right: 0
        }
      }

      &:nth-child(2) {
        box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.5), inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
        background-color: #fff;
        height: 65vh;
        padding: 50px 0px;
        text-align: center;

        @media (max-width: 480px){
          width: 90vw;
          margin-bottom: 20px;
        }

        > div {
          padding: 0 8%;
          width: 100%;
          // flex: 1;

          &:first-child {
            margin-bottom: 25px;

            img {
              height: auto;
              width: 20%;
            }
          }

          &:nth-child(2) {
            > div {
              margin-bottom: 30px;
              input {
                padding: 0 15px;
                height: 45px;
              }
            }
          }

          &:nth-child(3) {
            width: 100%;
            margin-top: 50px;

            button {
              height: 40px;
            }
          }

          &:last-child {
            font-size: 14px;
            margin-top: 12px;
            color: red;
          }
        }
      }
    }
  }
}
</style>
